<template lang="pug">
  b-card.w-100(no-body)
    div(slot="header") {{$t('user-connection-policy')}} <!-- {{$t('user-connection-policy')}} -->
    b-list-group
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.windows_version_check')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              b-form-select.w-100(
                size="sm"
                v-model="form.os"
                :options="options"
              )
            .msg
              span {{$t('management_page.windows_version_restriction')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.windows_auto_update_check')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_windows_auto_update",
                theme="bootstrap",
                :color="form.flag_windows_auto_update ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.disabled_enabled')}})
            .msg
              span {{$t('management_page.windows_auto_update_activation_check')}}
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.windows_antivirus_installation_execution_check')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_vaccine_check",
                theme="bootstrap",
                :color="form.flag_vaccine_check ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.disabled_enabled')}})
            .msg
              b-btn(size="sm" @click="showDialog('settingVaccine')") {{$t('setting')}}
              span.ml-2 {{$t('management_page.antivirus_installation_execution_restriction')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.windows_process_service_check')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_process_check",
                theme="bootstrap",
                :color="form.flag_process_check ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.disabled_enabled')}})
            .msg
              b-btn(size="sm" @click="showDialog('settingProcess')") {{$t('setting')}}
              span.ml-2 {{$t('management_page.process_service_running_restriction')}}
    
    dialog-setting-access(:show.sync="show.settingAccess" :value.sync="form.public_place_alert")
    dialog-setting-contract(:show.sync="show.settingContract" :version.sync="form.security_agreement_version")
    dialog-setting-vaccine(:show.sync="show.settingVaccine" :value.sync="form.vaccine")
    dialog-setting-process(:show.sync="show.settingProcess" :value.sync="form.process_check_list")
</template>

<script>
import Switches from "vue-switches"
import DialogSettingAccess from "./dialog/dialogSettingAccess.vue"
import DialogSettingContract from "./dialog/dialogSettingContract"
import DialogSettingVaccine from "./dialog/dialogSettingVaccine.vue"
import DialogSettingProcess from "./dialog/dialogSettingProcess.vue"

export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          time: 0,
          select: "win11",
        }
      },
    },
  },
  components: {
    Switches,
    DialogSettingAccess,
    DialogSettingContract,
    DialogSettingVaccine,
    DialogSettingProcess,
  },
  watch: {
    "form.flag_windows_auto_update"(val) {
      this.$emit("updateToggle", "flag_windows_auto_update", val)
    },
    "form.flag_public_place_alert"(val) {
      this.$emit("updateToggle", "flag_public_place_alert", val)
    },
    "form.flag_security_agreement"(val) {
      this.$emit("updateToggle", "flag_security_agreement", val)
    },
    "form.flag_vaccine_check"(val) {
      this.$emit("updateToggle", "flag_vaccine_check", val)
    },
    "form.flag_process_check"(val) {
      this.$emit("updateToggle", "flag_process_check", val)
    },
  },
  data() {
    return {
      show: {
        settingAccess: false,
        settingContract: false,
        settingVaccine: false,
        settingProcess: false,
        settingStorage: false,
      },
      options: [
        { text: `Windows 11/Server 2022 ${this.$t('management_page.or_higher')}`, value: "win11" },
        { text: `Window Server 2019 ${this.$t('management_page.or_higher')}`, value: "winserver19" },
        { text: `Window 10/Server 2016 ${this.$t('management_page.or_higher')}`, value: "win10" },
      ],
    }
  },
  methods: {
    showDialog(type) {
      this.show[type] = true
    },
  },
}
</script>

<style lang="scss" scoped></style>